import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import * as fromRoot from './../../../store/reducers';
import { TestTakerActions } from './../../../store/actions';
import { MyModal } from '../../common/my-modal/my-modal.component';
import { TimerComponent } from './timer/timer.component';
import { TestNavigationService } from '../../../services/test-navigation.service';
import { PreviewService } from '../../../services/preview.service';
import { ResponseService } from '../../../services/response.service';
import { TestContentService } from '../../../services/test-content.service';
import { ConfigHelper } from 'app/services/config.helper';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Component({
    selector: 'top-nav',
    template: require('./top-nav.component.html')
})
export class TopNavComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() testlet$: Observable<PgRendererDto.TestletDefinition>;
    @Input() assessmentItem$: Observable<PgRendererDto.AssessmentItem>;
    @Input() assessmentTest: PgRendererDto.AssessmentTest;
    @Input() activeAssessmentItem: PgRendererDto.AssessmentItem;
    @Input() testNavigation: PgRendererDto.TestNavigation;
    @ViewChild(TimerComponent) timer: TimerComponent;

    mode: string = _paragonConfig.mode;
    title: string;
    testlet: PgRendererDto.TestletDefinition;
    testletSubscription: Subscription;
    testNavigationSubscription: Subscription;
    backButtonClickSubscription: Subscription;

    constructor(
        private myModal: MyModal,
        private testContentService: TestContentService,
        private responseService: ResponseService,
        private previewService: PreviewService,
        private testNavigationService: TestNavigationService,
        private route: ActivatedRoute,
        private elementRef: ElementRef,
        private store: Store<fromRoot.State>
    ) {
    }

    ngOnInit() {
        this.testletSubscription = this.testlet$.subscribe(testlet => {
            this.testlet = testlet;
            this.updateTitle();
        });
        this.testNavigationSubscription = this.store.select(fromRoot.getTestNavigation).subscribe(testNavigation => {
            this.updateTitle(testNavigation);
        });
    }

    updateTitle(subscribedTestNavigation?: PgRendererDto.TestNavigation) {
        try {
            if (this.testlet && this.testNavigation && this.assessmentTest) {
                let title = null;
                if (subscribedTestNavigation != null) {
                    title = this.assessmentTest.TestParts[subscribedTestNavigation.testPartIndex].AssessmentSectionRefs[subscribedTestNavigation.testletIndex].PageHeader;
                } else {
                    title = this.assessmentTest.TestParts[this.testNavigation.testPartIndex].AssessmentSectionRefs[this.testNavigation.testletIndex].PageHeader;
                }
                this.title = title != null ? title : this.mode;
            } else {
                this.title = "";
            }
        } catch (error) {}
    }

    ngAfterViewInit() {
        const backButton = document.getElementById("btn-back");
        if (backButton) {
            this.backButtonClickSubscription = Observable.fromEvent(backButton, "click")
                .take(1)
                .do(x => {
                    this.onClickBack();
                })
                .delay(600)
                .repeat()
                .subscribe();
        }
    }

    ngOnDestroy() {
        if (this.testletSubscription) {
            this.testletSubscription.unsubscribe();
        }
    }

    onClickNext() {
        if (ConfigHelper.isIppMode() || ConfigHelper.isPreviewMode() || this.testNavigation.canGoNext == true) {
            this.testNavigationService.goNext(true);
        }
    }

    onClickBack() {
        const testNavigation = Object.assign({}, this.testNavigation);
        if (testNavigation.testletIndex > 0) {
            testNavigation.testletIndex--;
        } else if (testNavigation.testPartIndex > 0) {
            testNavigation.testPartIndex--;
            const testlets = this.testNavigationService.getTestletsByTestPart(this.assessmentTest.TestParts[testNavigation.testPartIndex], testNavigation.testPartIndex);
            testNavigation.testletIndex = testlets.length - 1;
        }
        this.store.dispatch(new TestTakerActions.SetTestNavigation(testNavigation));
    }

    checkResponses() {
        const interactions = this.testContentService.getReferencedInteractions(this.activeAssessmentItem);
        const responses = this.responseService.responses.filter(x => interactions.findIndex(i => i.InteractionId == x.InteractionId) >= 0);
        interactions.forEach(interaction => {
            const response = responses.find(r => r.InteractionId == interaction.InteractionId);
            if (!response) {
                responses.push({InteractionId: interaction.InteractionId, Items: []});
            }
        });
        this.testContentService.getPreviewResponseScores(responses, this.route.snapshot.params["snapshot-id"]).subscribe(responseScores => {
            this.myModal.showRegularDlg("Responses", this.previewService.getPreviewResponsesHtml(interactions, this.responseService, responseScores));
        });
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/top-nav/top-nav.component.ts